import { defineView } from "eddev/views"
import { Header } from "@components/site/Header"
import { useIntersectionObserver } from "usehooks-ts"
import { Appear } from "@components/motion/Appear"
import { themes } from "@components/atoms/Themed"
import { InsightTile } from "@components/atoms/InsightTile"
import { Select } from "@components/atoms/Select"
import { useRouter } from "eddev/routing"

export default defineView("taxonomy-insight-category", (props) => {
  const { isIntersecting, ref } = useIntersectionObserver({
    root: null,
    rootMargin: "0px",
    threshold: 0.1,
    freezeOnceVisible: true,
  })
  const router = useRouter()

  return (
    <div className="w-full">
      <div className="w-full bg-slate200" ref={ref}>
        <Header noPattern barClassName="!bg-slate200" />
        <div className="relative w-full">
          <div className="content-sized pt-6 pb-8 flex flex-col">
            <div className="flex flex-col gap-6 w-full md:w-cols-8">
              <Appear as="h1" className="type-sans-3-xl-semibold" slide active={isIntersecting} activeOnly>
                {props.insightCategory?.name || "Insights"}
              </Appear>
              {props.insightCategory?.description && (
                <Appear as="h2" className="type-serif-xl-regular" active={isIntersecting} activeOnly>
                  {props.insightCategory?.description}
                </Appear>
              )}
            </div>
          </div>
        </div>
      </div>

      <div className="content-sized my-8 flex flex-col gap-6">
        <div className="w-full flex gap-4">
          <Select
            options={[
              { label: "All Categories", value: "all" },
              ...(props.insightCategories?.nodes || []).map((type) => ({
                label: type.name || "",
                value: type.uri || "",
              })),
            ]}
            value={props.insightCategory?.uri || "all"}
            onChange={(value) => {
              // navigate to selected content type
              router.navigate(value === "all" ? "/insights" : value)
            }}
          />
          <Select
            options={[
              { label: "All Content Types", value: "all" },
              ...(props.insightTypes?.nodes || []).map((type) => ({ label: type.name || "", value: type.uri || "" })),
            ]}
            value={"all"}
            onChange={(value) => {
              // navigate to selected content type
              router.navigate(value === "all" ? "/insights" : value)
            }}
          />
        </div>
        <div className="w-full grid grid-cols-1 md:grid-cols-2 gap-4">
          {props.insightCategory?.insights?.nodes.map((item, ix) => {
            const delay = ix * 150

            return (
              <InsightTile
                key={item.id}
                id={item.id}
                uri={item.uri || ""}
                theme={item.insightHeader?.theme || undefined}
                image={item.insightHeader?.featuredImage || undefined}
                title={item.title || ""}
                type={item.insightHeader?.type?.insightType?.titleSingular || undefined}
                typeUri={item.insightHeader?.type?.uri || undefined}
                date={item.insightHeader?.displayedDate || undefined}
                active={isIntersecting}
                delay={delay}
              />
            )
          })}
        </div>
      </div>
    </div>
  )
})
